import React from 'react';
import ReactDOM from 'react-dom';
import {DiaLogMapEditorsStore} from '../../stores/CommandStore';
import DialogValue from './remote/DialogValue';

export default class DialogFieldBooleanEditor extends React.Component
{
	constructor(props) {
		super(props);
		this.record = this.props.data.defaultValue;
		if(this.record == undefined || this.record == null)
		{
			this.record = false;
		}
		this.state = {data:this.props.data};
		this.unsubscribeDiaLogMapEditorsStore = DiaLogMapEditorsStore.listen(this.onDiaLogMapEditors.bind(this));
	}

	onDiaLogMapEditors(dialogId,result)
	{
		if(this.props.dialogId == dialogId)
		{
			let dv = new DialogValue();
			dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
			dv.value = this.record+"";dv.entityId = this.props.data.entityId;
			//alert("DialogFieldStringEditor侦听");
			result[this.props.data.id] = dv;
		}
	}

	selectedChanged(value)
	{
		this.record = value;
	}

	componentDidMount()
	{
		$(this.inputField).on('ifChecked',this.selectedChanged.bind(this,true));
		$(this.inputField).on('ifUnchecked',this.selectedChanged.bind(this,false)); 
		$(this.inputField).iCheck({
	      checkboxClass: 'icheckbox_minimal-blue'
		});
		if(this.record == true)$(this.inputField).iCheck("check");
	}

	getInputDom()
	{
		let allowEdit = this.state.data.allowEdit;
		if(allowEdit)
		{
			return <input type="checkbox" className="minimal" ref={ node => this.inputField = node }/>;
		}
		else
		{
			return <input type="checkbox" className="minimal" ref={ node => this.inputField = node } disabled={true}/>;
		}
	}

	render()
	{
		
		let notNull=this.state.data.notNull;
		let _id = this.state.data.id;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';

		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'flex-start'};
		
		let inputdom = this.getInputDom();
		let labelStyle={paddingLeft:'5px',width:'auto',whiteSpace:'nowrap',textAlign:'right'};
		
		return(
			<div id={"EditorDialog"+_id} className='editorGroup' style={editorStyle}>
			  <label htmlFor={"inputDialog"+_id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle}>
			  	  {this.state.data.label}
			  </label>
			  <i className='fa fa-snowflake-o' style={_notNullStyle}></i>
			  {inputdom}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/dialog/DialogFieldBooleanEditor.js